import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchSalesCalls, ISalesCall, salesCallActionCreators, SalesCallActionKeys } from '..';
import { IPagedResponse } from '../../apiInterfaces';
import { businessEntityActionCreators } from '../../businessEntity';
import * as api from '../salesCallApi';
//import { salesCallsLoaded } from '../../businessEntity/businessEntitySelectors';

function* fetchSalesCallsSaga(action: FetchSalesCalls) {
  //const loaded: boolean = yield select(salesCallsLoaded, action.payload);

  //if (!loaded) {
  yield put(businessEntityActionCreators.setLoadingSalesCalls([action.payload.businessEntityId]));
  const response: IPagedResponse<ISalesCall> = yield call(
    api.FetchSalesCalls,
    action.payload.businessEntityId,
    action.payload.skip
  );

  // yield put(usersActionCreators.addUsers(response.users));
  yield put(
    businessEntityActionCreators.setSalesCallTotal({
      businessEntityId: action.payload.businessEntityId,
      totalItems: response.totalItems
    })
  );
  yield put(salesCallActionCreators.processSalesCalls(response.items));
  yield put(businessEntityActionCreators.addSalesCalls(response.items));
  yield put(businessEntityActionCreators.setLoadedSalesCalls([action.payload.businessEntityId]));
  yield put(businessEntityActionCreators.disableLoadingSalesCalls([action.payload.businessEntityId]));
  //}
}

export function* watchFetchSalesCalls() {
  yield takeEvery(SalesCallActionKeys.FETCH_SALESCALLS, fetchSalesCallsSaga);
}
